if(!customElements.get('order-replacements-drawer')) {
    customElements.define(
        'order-replacements-drawer',
        class OrderReplacementsDrawer extends HTMLElement {
            constructor() {
                super();
                this.drawer = null;
                this.overlay = null;
                this.drawerTitle = null;
                this.activeClass = 'order-replacements-drawer--open';
                this.replacementId = null;
            }
        
            connectedCallback() {
                this.init();
                this.bindEvents();
            }
        
            disconnectedCallback() {
                this.removeEventListeners();
            }
        
            init() {
                // The host element is the drawer (it has class order-replacements-drawer); querySelector only searches descendants
                this.drawer = this;
                this.overlay = this.querySelector('.order-replacements-drawer__overlay');
                this.drawerTitle = this.querySelector('.order-replacements-drawer__title');
            }
        
            bindEvents() {
                // Use event delegation so buttons added after API response (e.g. in tracker) still work
                document.addEventListener('click', this.delegatedClickHandler = (e) => {
                    const btn = e.target.closest('.shipment__item-btn--replacement');
                    if (btn) {
                        e.preventDefault();
                        this.openDrawer(btn);
                    }
                });
        
                // Bind close buttons
                const closeButton = this.querySelector('.order-replacements-drawer__close-button') ||
                                   document.querySelector('.order-replacements-drawer__close-button');

                closeButton?.addEventListener('click', () => this.closeDrawer());
                this.overlay?.addEventListener('click', () => this.closeDrawer());
        
                // Bind escape key
                this.escapeHandler = (e) => {
                    if (e.key === 'Escape' && this.drawer?.classList.contains(this.activeClass)) {
                        this.closeDrawer();
                    }
                };
                document.addEventListener('keydown', this.escapeHandler);
            }
        
            openDrawer(btn) {
                if (!this.drawer) return;
        
                // Store replacement id so getReplacementHtml can find the content
                this.replacementId = btn.dataset.replacementId;
        
                // Get data attributes from the clicked button
                const title = btn.dataset.title || 'Replacements';
                if (this.drawerTitle && title) {
                    this.drawerTitle.innerHTML = title.charAt(0).toUpperCase() + title.slice(1);
                }

                // get the replacement html based on the data-replacement-id
                const replacementHtml = this.getReplacementHtml();
                if (!replacementHtml) return;

                this.drawer.querySelector('.order-replacements-drawer__content').innerHTML = replacementHtml;

                // Open drawer
                this.drawer.classList.add(this.activeClass);

                document.body.classList.add('drawer-open');
            }
        
            closeDrawer() {
                if (!this.drawer) return;

                // Close drawer
                this.drawer.classList.remove(this.activeClass);
                document.body.classList.remove('drawer-open');
            }
        
            removeEventListeners() {
                if (this.escapeHandler) {
                    document.removeEventListener('keydown', this.escapeHandler);
                }
                if (this.delegatedClickHandler) {
                    document.removeEventListener('click', this.delegatedClickHandler);
                }
            }

            getReplacementHtml() {
                const contentEl = document.querySelector(`.shipment__item-replacements__drawer-content[data-replacement-id="${this.replacementId}"]`);
                if (!contentEl) return null;

                return contentEl.innerHTML;
            }
        }
    )
}

// customElements.define('order-replacements-drawer', OrderReplacementsDrawer);